/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TreasuryVester,
  TreasuryVesterInterface,
} from "../TreasuryVester";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_siloToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_vestingAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_vestingBegin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_vestingCliff",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_vestingEnd",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_revocable",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastUpdate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "recipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revocable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "revoke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "setRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vestingAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestingBegin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestingCliff",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestingEnd",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type TreasuryVesterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TreasuryVesterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TreasuryVester__factory extends ContractFactory {
  constructor(...args: TreasuryVesterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TreasuryVester";
  }

  deploy(
    _siloToken: string,
    _recipient: string,
    _vestingAmount: BigNumberish,
    _vestingBegin: BigNumberish,
    _vestingCliff: BigNumberish,
    _vestingEnd: BigNumberish,
    _revocable: boolean,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TreasuryVester> {
    return super.deploy(
      _siloToken,
      _recipient,
      _vestingAmount,
      _vestingBegin,
      _vestingCliff,
      _vestingEnd,
      _revocable,
      overrides || {}
    ) as Promise<TreasuryVester>;
  }
  getDeployTransaction(
    _siloToken: string,
    _recipient: string,
    _vestingAmount: BigNumberish,
    _vestingBegin: BigNumberish,
    _vestingCliff: BigNumberish,
    _vestingEnd: BigNumberish,
    _revocable: boolean,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _siloToken,
      _recipient,
      _vestingAmount,
      _vestingBegin,
      _vestingCliff,
      _vestingEnd,
      _revocable,
      overrides || {}
    );
  }
  attach(address: string): TreasuryVester {
    return super.attach(address) as TreasuryVester;
  }
  connect(signer: Signer): TreasuryVester__factory {
    return super.connect(signer) as TreasuryVester__factory;
  }
  static readonly contractName: "TreasuryVester";
  public readonly contractName: "TreasuryVester";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TreasuryVesterInterface {
    return new utils.Interface(_abi) as TreasuryVesterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TreasuryVester {
    return new Contract(address, _abi, signerOrProvider) as TreasuryVester;
  }
}
